import { call, put, takeEvery } from 'redux-saga/effects';
import { targetedCatalogActionCreators, TargetedCatalogActionKeys, TargetedCatalogItemSearch } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { IProduct, productsActionCreators } from '../../products';
import { showFailedRequestDialog } from '../../sagaUtils';
import { itemSearch } from '../targetedCatalogApi';

function* targetedCatalogItemSearchSaga(action: TargetedCatalogItemSearch) {
  yield put(targetedCatalogActionCreators.toggleItemSearch());
  const response: IApiExecuteRespone<IProduct[]> = yield call(itemSearch, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(
      targetedCatalogActionCreators.setItemSearchResults({
        ...action.payload,
        itemIds: response.value.map(x => x.itemId)
      })
    );
    yield put(productsActionCreators.setProducts(response.value));
  }

  yield put(targetedCatalogActionCreators.toggleItemSearch());
}

export function* watchTargetedCatalogItemSearch() {
  yield takeEvery(TargetedCatalogActionKeys.TARGETED_CATALOG_ITEM_SEARCH, targetedCatalogItemSearchSaga);
}
